// extracted by mini-css-extract-plugin
export default {"filter":"Panel_filter__rMEir","inputsRow":"Panel_inputsRow__hJQFe","tabs":"Panel_tabs__tSWnH","spacer":"Panel_spacer__1o82I"};